import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";

// Config pública do app web `painel-farmacias` (projeto onio-chat-farmacias).
// Chave de browser: segurança está nas rules + authorized domains, não no segredo.
const firebaseConfig = {
  apiKey: "AIzaSyCqL8AjIye1raRcLiCzOQ3eqLx9XLzAnQk",
  authDomain: "onio-chat-farmacias.firebaseapp.com",
  projectId: "onio-chat-farmacias",
  messagingSenderId: "43570562098",
  appId: "1:43570562098:web:d10c016edec4a2ce8e682b",
};

/**
 * Único bucket do projeto (registrado no Firebase Storage pela infra). Guarda
 * os logos em `logos/<slug>/` e as fotos da landing em `fotos/<slug>/`.
 */
export const LOGOS_BUCKET = "onio-chat-farmacias-logos";

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app, `gs://${LOGOS_BUCKET}`);

export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

if (import.meta.env.VITE_USE_EMULATORS === "1") {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8085);
  connectStorageEmulator(storage, "127.0.0.1", 9199);
}
